export const BASE_PATH = process.env.BASE_PATH || "/special-permit-ui";

export const ROUTES = {
  HOME: "/",
  ELIGIBILITY: "/eligibility",
  APPLICATION_DETAIL: "/application-detail",
  VEHICLE_INSURANCE: "/vehicle-insurance",
  CONTACT_DETAIL: "/contact-detail",
  REVIEW: "/review",
  MAINTENANCE: "/maintenance",
  ERROR: (code: string) => `/error/${code}`,
} as const;
